export const CURRENT_ASSIGNED_TRAINER = "assigned_trainer";
